const system: any = {
  // menu: /workflow:*/,
  menu: 'workflow:task_scheduler',
  scheduler: 'workflow:task_scheduler',
  executionLog: 'connection-message:execution',
};

export default system;